import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store from './redux/store';
import { persistStore } from 'redux-persist';
import App from './App';
//import reportWebVitals from './reportWebVitals';
import Api from './services/api';
import { createBrowserHistory } from 'history';
import './index.css';


window.api = new Api();
const basename = import.meta.env.BASE_URL;
let persistor = persistStore(store);

export const history = createBrowserHistory({ basename });

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
